var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClipboard = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.547 5.509H6.005A2 2 0 0 0 4 7.5v22.516c0 1.095.898 1.992 2.005 1.992h19.99A2 2 0 0 0 28 30.017V7.501a2 2 0 0 0-2.005-1.992h-2.458V3.045h-3.626S19.649 0 16.084 0s-3.92 3.048-3.92 3.048H8.573zm14.99 2H26v22.5H6v-22.5h2.526L8.5 9.987h15.037zM10.573 5.015h3.413V3.76s.04-1.813 2.028-1.813 1.988 1.758 1.988 1.758V4.94h3.494v3.098H10.517zM16 5.009a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-7.5 13v3h3v-2.964zm0 5v3h3v-2.964zm0-10v3h3v-2.964zm5 .01V16h10v-3zm0 10V26h10v-3zm0-5V21h10v-3z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClipboard);
export default ForwardRef;